<template>
    <AppForm
        v-if="loaded"
        :loading="loading"
        :is-new="false"
        heading="Settings"
        @submit="submitHandler"
    >
        <template v-slot:main>
            <FormGroup
                label="E-post"
                label-for="email"
            >
                <InputField
                    v-model="settings.email"
                    :required="true"
                    type="email"
                    name="email"
                />
            </FormGroup>
            <FormGroup
                label="Exempel"
                label-for="exemple"
            >
                <WYSIWYG v-model="settings.exemple"/>
            </FormGroup>
            <FormGroup
                label="Media item"
            >
                <MediaField/>
            </FormGroup>
            <FormGroup
                label="Multiple media items"
            >
                <MultipleMediaField/>
            </FormGroup>
        </template>
    </AppForm>
</template>

<script>
import FormGroup from '../../components/form/FormGroup.vue';
import InputField from '../../components/form/InputField.vue';
import WYSIWYG from '../../components/form/WYSIWYG.vue';
import MediaField from '../../components/form/MediaField.vue';
import MultipleMediaField from '../../components/form/MultipleMediaField.vue';
import AppForm from '../../components/form/AppForm.vue';
import { get, store } from '../../utils/apiHelper';

export default {
    components: {
        AppForm,
        FormGroup,
        WYSIWYG,
        InputField,
        MediaField,
        MultipleMediaField,
    },
    data: () => ({
        loaded: false,
        loading: false,
        settings: {
            email: null,
            exemple: null,
            first_image: null,
            second_image: null,
        },
    }),
    async created() {
        const settings = await get('/api/settings');

        for (let i = 0; i < settings.length; i++) {
            const setting = settings[i];
            this.settings[setting.name] = setting.value;
        }

        this.loaded = true;
    },
    methods: {
        async submitHandler() {
            this.loading = true;
            await store('/api/settings', { data: this.settings });
            this.loading = false;
        },
    },
};
</script>

<style lang="postcss" scoped>
</style>
